export default __webpack_public_path__ + "01402755a136d79f6c61c647993e589d.png";